import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin } from 'lucide-react';

const Footer = () => {
  const navigation = [
    {
      title: 'Company',
      links: [
        { name: 'About Us', path: '/about' },
        { name: 'Process', path: '/process' },
        { name: 'Contact', path: '/contact' }
      ]
    },
    {
      title: 'Solutions',
      links: [
        { name: 'Services', path: '/services' },
        { name: 'Industries', path: '/industries' }
      ]
    }
  ];

  return (
    <footer className="footer bg-gray-900 text-gray-300">
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_bilingual-print-team/artifacts/tyuaudpu_LOGO-LATIN-TALENT-REMOTE.png"
                alt="Latin Talent Remote"
                className="h-20 w-auto"
              />
            </Link>
            <p className="text-lg mb-6 leading-relaxed">
              Specialized CSR & Graphic Production Support
            </p>
            <div className="space-y-3">
              <a
                href="mailto:contact@latintalentremote.com"
                className="flex items-center gap-3 hover:text-cyan-400 transition-colors"
              >
                <Mail className="w-5 h-5" />
                <span>contact@latintalentremote.com</span>
              </a>
              <a
                href="#"
                className="flex items-center gap-3 hover:text-cyan-400 transition-colors"
              >
                <Linkedin className="w-5 h-5" />
                <span>Connect on LinkedIn</span>
              </a>
            </div>
          </div>

          {/* Navigation */}
          {navigation.map((section, index) => (
            <div key={index}>
              <h3 className="text-white font-bold text-lg mb-4">{section.title}</h3>
              <ul className="space-y-3">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link
                      to={link.path}
                      className="hover:text-cyan-400 transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm">
              © 2026 Latin Talent Remote. All Rights Reserved.
            </p>
            <div className="flex gap-6">
              <Link to="#" className="text-sm hover:text-cyan-400 transition-colors">
                Privacy Policy
              </Link>
              <Link to="#" className="text-sm hover:text-cyan-400 transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;